<template>
  <div>
    <div class="login">
      <section class="hero is-medium is-primary is-bold">
        <div class="hero-body">
          <div class="container">
            <h1 class="title">VOIP Dashboard</h1>
            <!-- <h2 class="subtitle">SubTitle</h2> -->
          </div>
        </div>
      </section>

      <LoginForm :error="authError" @submit="login" />
    </div>

    <footer class="footer">
      <div class="columns is-mobile">
        <div class="column">
          <p class="heading">
            <strong>Ottawa</strong>
          </p>
          <p class="heading">613.691.0226</p>
        </div>

        <div class="column">
          <p class="heading">
            <strong>Montreal</strong>
          </p>
          <p class="heading">514.904.1270</p>
        </div>
        <div class="column">
          <p class="heading">
            <strong>Toronto</strong>
          </p>
          <p class="heading">647.943.0550</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src
import LoginForm from "../components/LoginForm";

export default {
  name: "Login",
  data() {
    return {
      authError: null
    };
  },
  components: {
    LoginForm
  },
  methods: {
    login(credentials) {
      this.authing = true;
      this.$cnc
        .auth(credentials)
        .then(authToken => {
          this.authing = false;
          if (authToken) {
            this.$router.replace({
              name: "Account-update",
              params: { accountId: credentials.username }
            });
          } else {
            this.authError = "Incorrect username or password";
          }
        })
        .catch(err => {
          this.authError = err.message;
        });
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login {
  padding: 0;
  margin: 0;
  width: 100%;
}
.footer {
  padding: 15px 20px;
  position: absolute;
  bottom: 0;
  text-align: center;
  width: 100%;
}
</style>

